import Vue from 'vue'
import Vuex from 'vuex'
import pageStore from './stores/pageStore'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  modules: {
    pageStore
  }
})
